import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { breakpoints } from '@chegg-ui/theme';
import { css } from 'styled-components';
export var xxlBreakpoint = 1920;
var breakpointsMap = {
  smAndLower: "(max-width: ".concat(breakpoints.sm.max, ")"),
  mdAndLower: "(max-width: ".concat(breakpoints.md.max, ")"),
  mdAndHigher: "(min-width: ".concat(breakpoints.md.min, ")"),
  lgAndLower: "(max-width: ".concat(breakpoints.lg.max, ")"),
  lgAndHigher: "(min-width: ".concat(breakpoints.lg.min, ")"),
  xlAndHigher: "(min-width: ".concat(breakpoints.xl.min, ")"),
  xxlAndHigher: "(min-width: ".concat(xxlBreakpoint, "px)")
};
export function getPreloadMediaConfigForBreakpoints(breakpoints, breakpointsConfig) {
  if (!breakpoints || breakpoints.length === 0) return {
    "default": ''
  };
  var descendingBreakpoints = ['xl', 'lg', 'md', 'sm'];
  var imageBreakpoints = {};
  var firstSeenBreakpointIndex = -1;
  var lastSeenBreakpointIndex = -1;
  descendingBreakpoints.map(function (breakpoint, index) {
    var breakpointExists = breakpoints.includes(breakpoint);
    var adjacentBreakpointExists = breakpoints.includes(descendingBreakpoints[index + 1]); // Used for adding breakpoints apart from the default one

    if (breakpointExists) {
      // used to detect uncovered ranges in `else`
      lastSeenBreakpointIndex = index;

      if (firstSeenBreakpointIndex < 0) {
        firstSeenBreakpointIndex = index;
      }

      var largestBreakpointIndex = index === 0;
      var smallestBreakpointIndex = index === descendingBreakpoints.length - 1; // if largest breakpoint is there, always include it in result

      if (largestBreakpointIndex) {
        imageBreakpoints[breakpoint] = {
          'min-width': breakpointsConfig[breakpoint].min
        }; // if smallest breakpoint is there, always include it in result
      } else if (smallestBreakpointIndex) {
        imageBreakpoints[breakpoint] = {
          'max-width': breakpointsConfig[breakpoint].max
        }; // in case of adjacent breakpoints, min-width is also added
        // to the current breakpoint
      } else if (adjacentBreakpointExists) {
        imageBreakpoints[breakpoint] = {
          'min-width': breakpointsConfig[breakpoint].min,
          'max-width': breakpointsConfig[breakpoint].max
        }; // for every other case, just add max-width
      } else {
        imageBreakpoints[breakpoint] = {
          'max-width': breakpointsConfig[breakpoint].max
        };
      } // used for detecting where to put default and where to alter
      // existing breakpoints

    } else {
      var noBreakpointEncounteredYet = firstSeenBreakpointIndex < 0;

      if (noBreakpointEncounteredYet) {
        imageBreakpoints["default"] = {
          'min-width': breakpointsConfig[breakpoint].min
        };
      } else if (adjacentBreakpointExists) {
        if (lastSeenBreakpointIndex === 0) {
          var firstSeenBreakpointPlusOne = descendingBreakpoints[firstSeenBreakpointIndex + 1];
          imageBreakpoints["default"] = {
            'min-width': breakpointsConfig[breakpoint].min,
            'max-width': breakpointsConfig[firstSeenBreakpointPlusOne].max
          };
        } else {
          var lastSeenBreakpoint = descendingBreakpoints[lastSeenBreakpointIndex];
          imageBreakpoints[lastSeenBreakpoint] = _objectSpread(_objectSpread({}, imageBreakpoints[lastSeenBreakpoint]), {}, {
            'min-width': breakpointsConfig[breakpoint].min
          });
        }
      }
    }
  });

  if (breakpoints.length === 1 && breakpoints.includes(descendingBreakpoints[0])) {
    imageBreakpoints["default"] = {
      'max-width': breakpointsConfig[descendingBreakpoints[1]].max
    };
  }

  var stringifiedImageBreakpoints = {};
  Object.keys(imageBreakpoints).forEach(function (breakpoint) {
    var typedBreakpoint = breakpoint;
    var imageBreakpointsObject = imageBreakpoints[typedBreakpoint];
    stringifiedImageBreakpoints[typedBreakpoint] = "(".concat(Object.keys(imageBreakpointsObject).sort().reverse().map(function (media) {
      return "".concat(media, ": ").concat(imageBreakpointsObject[media]);
    }).join(' and '), ")");
  });
  return stringifiedImageBreakpoints;
}

/** @deprecated: Use `mediaQuery` as it supports intellisense as well */
export var getMediaQueryV2 = function () {
  var media = {};
  Object.keys(breakpointsMap).forEach(function (breakpoint) {
    media[breakpoint] = function (literals) {
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }

      return css(["@media ", "{", ";}"], breakpointsMap[breakpoint], css.apply(void 0, [literals].concat(args)));
    };
  });
  return media;
}();
Object.freeze(breakpointsMap);
/** Helper for media queries to be used in styled-component css.
 *
 * @example
 *
 * ${mediaQuery.lgAndHigher} {
 *    width: 200px;
 * }
 *
 * ${mediaQuery.xlAndHigher} {
 *    ${props => `width: ${props.width};`}
 * }
 */

export var mediaQuery = Object.keys(breakpointsMap).reduce(function (mq, breakpoint) {
  return _objectSpread(_objectSpread({}, mq), {}, _defineProperty({}, breakpoint, "@media ".concat(breakpointsMap[breakpoint])));
}, {});